import { defineMessages } from 'react-intl';

export default defineMessages({
  modalTitle: {
    id: 'App.ManageHudVoucherDetails.RepaymentAgreement.AddRepaymentAgreementModal.Title',
    defaultMessage: 'Add Repayment Agreement',
  },
  modalTitleModify: {
    id: 'App.ManageHudVoucherDetails.RepaymentAgreement.AddRepaymentAgreementModal.TitleModify',
    defaultMessage: 'Modify Repayment Agreement',
  },
  modalDescription: {
    id: 'App.ManageHudVoucherDetails.RepaymentAgreement.AddRepaymentAgreementModal.Description',
    defaultMessage:
      'Provide the required details below for the Repayment Agreement.',
  },
  modalDescriptionModify: {
    id: 'App.ManageHudVoucherDetails.RepaymentAgreement.AddRepaymentAgreementModal.DescriptionModify',
    defaultMessage:
      'Provide the required details below for the Repayment Agreement modification.',
  },
  cancel: {
    id: 'App.ManageHudVoucherDetails.RepaymentAgreement.AddRepaymentAgreementModal.Cancel',
    defaultMessage: 'Cancel',
  },
  save: {
    id: 'App.ManageHudVoucherDetails.RepaymentAgreement.AddRepaymentAgreementModal.Save',
    defaultMessage: 'Save',
  },
  agreementTypeLabel: {
    id: 'App.ManageHudVoucherDetails.RepaymentAgreement.AddRepaymentAgreementModal.AgreementTypeLabel',
    defaultMessage: 'Agreement Type',
  },
  agreementTypePlaceholder: {
    id: 'App.ManageHudVoucherDetails.RepaymentAgreement.AddRepaymentAgreementModal.AgreementTypePlaceholder',
    defaultMessage: 'Select an option',
  },
  newOrOngoingLabel: {
    id: 'App.ManageHudVoucherDetails.RepaymentAgreement.AddRepaymentAgreementModal.NewOrOngoingLabel',
    defaultMessage: 'New or Ongoing?',
  },
  newOrOngoingPlaceholder: {
    id: 'App.ManageHudVoucherDetails.RepaymentAgreement.AddRepaymentAgreementModal.NewOrOngoingPlaceholder',
    defaultMessage: 'Select an option',
  },
  householdStatusLabel: {
    id: 'App.ManageHudVoucherDetails.RepaymentAgreement.AddRepaymentAgreementModal.HouseholdStatusLabel',
    defaultMessage: 'Household Status',
  },
  householdStatusPlaceholder: {
    id: 'App.ManageHudVoucherDetails.RepaymentAgreement.AddRepaymentAgreementModal.HouseholdStatusPlaceholder',
    defaultMessage: 'Select an option',
  },
  unitResidentLabel: {
    id: 'App.ManageHudVoucherDetails.RepaymentAgreement.AddRepaymentAgreementModal.UnitResidentLabel',
    defaultMessage: 'Unit / Resident',
  },
  unitResidentPlaceholder: {
    id: 'App.ManageHudVoucherDetails.RepaymentAgreement.AddRepaymentAgreementModal.UnitResidentPlaceholder',
    defaultMessage: 'Select or type to search',
  },
  vacantOptionLabel: {
    id: 'App.ManageHudVoucherDetails.RepaymentAgreement.AddRepaymentAgreementModal.VacantOptionLabel',
    defaultMessage: 'Vacant',
  },
  agreementDateLabel: {
    id: 'App.ManageHudVoucherDetails.RepaymentAgreement.AddRepaymentAgreementModal.AgreementDateLabel',
    defaultMessage: 'Agreement Date',
  },
  agreementDateError: {
    id: 'App.ManageHudVoucherDetails.RepaymentAgreement.AddRepaymentAgreementModal.AgreementDateError',
    defaultMessage:
      'Agreement date cannot be later than the first day of the voucher month.',
  },
  agreementAmountLabel: {
    id: 'App.ManageHudVoucherDetails.RepaymentAgreement.AddRepaymentAgreementModal.AgreementAmountLabel',
    defaultMessage: 'Agreement Amount',
  },
  agreementAmountError: {
    id: 'App.ManageHudVoucherDetails.RepaymentAgreement.AddRepaymentAgreementModal.AgreementAmountError',
    defaultMessage: 'Must be greater than 0. No decimals allowed.',
  },
  currencyWholeNumberError: {
    id: 'App.ManageHudVoucherDetails.RepaymentAgreement.AddRepaymentAgreementModal.CurrencyWholeNumberError',
    defaultMessage: 'Enter a whole number only. No decimals allowed.',
  },
  beginningBalanceLabel: {
    id: 'App.ManageHudVoucherDetails.RepaymentAgreement.AddRepaymentAgreementModal.BeginningBalanceLabel',
    defaultMessage: 'Beginning Balance',
  },
  beginningBalanceTooltip: {
    id: 'App.ManageHudVoucherDetails.RepaymentAgreement.AddRepaymentAgreementModal.BeginningBalanceTooltip',
    defaultMessage:
      'For "Ongoing" repayments, add the original Beginning Balance of the agreement.' +
      ' This will be auto-populated for "New" repayments.',
  },
  totalPaymentLabel: {
    id: 'App.ManageHudVoucherDetails.RepaymentAgreement.AddRepaymentAgreementModal.TotalPaymentLabel',
    defaultMessage: 'Total Payment',
  },
  totalPaymentTooltip: {
    id: 'App.ManageHudVoucherDetails.RepaymentAgreement.AddRepaymentAgreementModal.TotalPaymentTooltip',
    defaultMessage:
      'For N-None agreement type this field is disabled and set to $0.',
  },
  agreementChangeAmountLabel: {
    id: 'App.ManageHudVoucherDetails.RepaymentAgreement.AddRepaymentAgreementModal.AgreementChangeAmountLabel',
    defaultMessage: 'Agreement Change Amount',
  },
  agreementChangeAmountTooltip: {
    id: 'App.ManageHudVoucherDetails.RepaymentAgreement.AddRepaymentAgreementModal.AgreementChangeAmountTooltip',
    defaultMessage:
      'Fortress auto-calculates this field at initial creation. Agreement Change Amount = Agreement Amount',
  },
  endingBalanceLabel: {
    id: 'App.ManageHudVoucherDetails.RepaymentAgreement.AddRepaymentAgreementModal.EndingBalanceLabel',
    defaultMessage: 'Ending Balance',
  },
  endingBalanceTooltip: {
    id: 'App.ManageHudVoucherDetails.RepaymentAgreement.AddRepaymentAgreementModal.EndingBalanceTooltip',
    defaultMessage:
      'Field is auto-calculated by Fortress. ' +
      'Calculated as: Ending Balance = Beginning balance + Agreement Change Amount (if applicable) − Total Payments',
  },
  endingBalanceNegativeError: {
    id: 'App.ManageHudVoucherDetails.RepaymentAgreement.AddRepaymentAgreementModal.EndingBalanceNegativeError',
    defaultMessage: 'Cannot be negative, check tooltip.',
  },
  amountRetainedLabel: {
    id: 'App.ManageHudVoucherDetails.RepaymentAgreement.AddRepaymentAgreementModal.AmountRetainedLabel',
    defaultMessage: 'Amount Retained',
  },
  amountRetainedTooltip: {
    id: 'App.ManageHudVoucherDetails.RepaymentAgreement.AddRepaymentAgreementModal.AmountRetainedTooltip',
    defaultMessage:
      'Auto-set at 20% of the total payment. Cannot exceed 20% of the total payment collected. ' +
      'Applies to Tenant Repayment Agreements only.',
  },
  amountRetainedError: {
    id: 'App.ManageHudVoucherDetails.RepaymentAgreement.AddRepaymentAgreementModal.AmountRetainedError',
    defaultMessage:
      'Amount Retained cannot exceed 20% of Total Payment or Total Payment.',
  },
  amountRequestedLabel: {
    id: 'App.ManageHudVoucherDetails.RepaymentAgreement.AddRepaymentAgreementModal.AmountRequestedLabel',
    defaultMessage: 'Amount Requested',
  },
  amountRequestedTooltip: {
    id: 'App.ManageHudVoucherDetails.RepaymentAgreement.AddRepaymentAgreementModal.AmountRequestedTooltip',
    defaultMessage:
      'Field is auto-calculated by Fortress. ' +
      'Calculated as: Amount Requested = Agreement Change Amount - Total Payment + Amount Retained (if applicable)',
  },
  agreementIdLabel: {
    id: 'App.ManageHudVoucherDetails.RepaymentAgreement.AddRepaymentAgreementModal.AgreementIdLabel',
    defaultMessage: 'Agreement ID',
  },
  agreementIdPlaceholder: {
    id: 'App.ManageHudVoucherDetails.RepaymentAgreement.AddRepaymentAgreementModal.AgreementIdPlaceholder',
    defaultMessage: 'Enter agreement ID (1-14 alphanumeric characters)',
  },
  agreementIdTooltip: {
    id: 'App.ManageHudVoucherDetails.RepaymentAgreement.AddRepaymentAgreementModal.AgreementIdTooltip',
    defaultMessage:
      'Agreement ID is auto-populated by Fortress for new Agreements. ' +
      'If this is an existing Repayment Agreement, please enter the ID already assigned to the agreement. ',
  },
  agreementIdError: {
    id: 'App.ManageHudVoucherDetails.RepaymentAgreement.AddRepaymentAgreementModal.AgreementIdError',
    defaultMessage:
      'Agreement ID must be 1-14 alphanumeric characters (A-Z, 0-9). ' +
      'No spaces, hyphens, or special characters.',
  },
});
